export default {"src":"/_next/static/media/waking-up.colour.7736da0d.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};